import { Color } from '@gousto-internal/citrus-react'

export type DiscountBox = {
  discountValue: string
  discountSuffix: string
  label: string
  bgColor: Color
  textColor: Color
}

export const DEFAULT_BOXES: DiscountBox[] = [
  {
    discountValue: '50%',
    discountSuffix: 'OFF',
    label: '1st box',
    bgColor: Color.Primary_600,
    textColor: Color.White,
  },
  {
    discountValue: '40%',
    discountSuffix: 'OFF',
    label: '2nd box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
  {
    discountValue: '20%',
    discountSuffix: 'OFF',
    label: '3rd-6th box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
]

export const TAPERED_DISCOUNT_BOX: DiscountBox[] = [
  {
    discountValue: '50%',
    discountSuffix: 'OFF',
    label: '1st box',
    bgColor: Color.Primary_600,
    textColor: Color.White,
  },
  {
    discountValue: '40%',
    discountSuffix: 'OFF',
    label: '2nd box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
  {
    discountValue: '20%',
    discountSuffix: 'OFF',
    label: '3rd-4th box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
  {
    discountValue: '10%',
    discountSuffix: 'OFF',
    label: '5th-8th box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
]
